import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async (params) => {
  return await dponetAPI.get('monitoring_management_pdcas', { params })
}

const show = async ({ pdcaId }) => {
  return await dponetAPI.get(`monitoring_management_pdcas/${pdcaId}`)
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('monitoring_management_pdcas', {
    monitoringManagementPdca: data,
  })
}

const update = async ({ pdcaId, ...data }) => {
  return await dponetAPI.put(`monitoring_management_pdcas/${pdcaId}`, {
    monitoringManagementPdca: data,
  })
}

const destroy = async ({ pdcaId }) => {
  return await dponetAPI.delete(`monitoring_management_pdcas/${pdcaId}`)
}

const uploadFiles = async ({ pdcaId, attachments }) => {
  return await dponetAPI.postForm(
    `monitoring_management_pdcas/${pdcaId}/attachments`,
    { monitoringManagementPdca: { attachments } },
  )
}

const destroyFile = async ({ pdcaId, fileId }) => {
  return await dponetAPI.delete(
    `monitoring_management_pdcas/${pdcaId}/attachments/${fileId}`,
  )
}

const listCycles = async ({ pdcaId, ...params }) => {
  return await dponetAPI.get(`monitoring_management_pdcas/${pdcaId}/cycles`, {
    params,
  })
}

const showCycles = async ({ pdcaId, pdcaCycleId }) => {
  return await dponetAPI.get(
    `monitoring_management_pdcas/${pdcaId}/cycles/${pdcaCycleId}`,
  )
}

const destroyCycles = async ({ pdcaId, pdcaCycleId }) => {
  return await dponetAPI.delete(
    `monitoring_management_pdcas/${pdcaId}/cycles/${pdcaCycleId}`,
  )
}

const createCycle = async ({ pdcaId, ...data }) => {
  return await dponetAPI.post(`monitoring_management_pdcas/${pdcaId}/cycles`, {
    monitoringManagementPdcaCycle: data,
  })
}

const updateCycle = async ({ pdcaId, pdcaCycleId, ...data }) => {
  return await dponetAPI.put(
    `monitoring_management_pdcas/${pdcaId}/cycles/${pdcaCycleId}`,
    {
      monitoringManagementPdcaCycle: data,
    },
  )
}

export default {
  list,
  show,
  create,
  update,
  destroy,
  uploadFiles,
  destroyFile,
  listCycles,
  showCycles,
  destroyCycles,
  createCycle,
  updateCycle,
}
